/**
 * SQL API Service for RJBD Matrimonial
 * Handles all API calls to the SQL Server backend
 */
import { getApiUrl } from '@/config/api';

const API_BASE_URL = getApiUrl();

export interface RegisterData {
  userId: string;
  basicDetails: {
    profileFor: string;
    firstName: string;
    lastName: string;
    mobileNo: string;
    email: string;
    profession: string;
    password: string;
  };
  personalDetails: {
    dob: Date;
    gender: string;
    religion: string;
    caste: string;
    motherTongue: string;
    maritalStatus: string;
    height: number;
    weight: number;
  };
}

export interface ApiResponse {
  success: boolean;
  message: string;
  user?: any;
}

export const sqlApi = {
  /**
   * Register a new user
   */
  async register(userData: RegisterData): Promise<ApiResponse> {
    try {
      console.log('🚀 Making registration API call to:', `${API_BASE_URL}/auth/register`);
      console.log('📝 Full user data:', JSON.stringify(userData, null, 2));

      const response = await fetch(`${API_BASE_URL}/auth/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });

      console.log('📥 Response status:', response.status);
      
      const data = await response.json();
      console.log('📥 Registration response:', data);

      if (!response.ok) {
        throw new Error(data.message || 'Registration failed');
      }

      return data;
    } catch (error) {
      console.error('❌ Registration API error:', error);
      throw error;
    }
  },

  /**
   * Login user
   */
  async login(loginData: { email?: string; mobile?: string; password: string }): Promise<ApiResponse> {
    try {
      console.log('🔐 Making login API call to:', `${API_BASE_URL}/auth/login`);
      console.log('📝 Login data:', { ...loginData, password: '***' });

      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(loginData),
      });

      console.log('📥 Login response status:', response.status);
      
      const data = await response.json();
      console.log('📥 Login response data:', data);
      console.log('🔍 Login API user data structure:', JSON.stringify(data.user, null, 2));
      console.log('🔍 Login API user profession field:', data.user?.profession);
      console.log('🔍 Login API user basicDetails:', data.user?.basicDetails);
      console.log('🔍 Login API user basicDetails profession:', data.user?.basicDetails?.profession);

      if (!response.ok) {
        throw new Error(data.message || `Login failed (HTTP ${response.status})`);
      }

      console.log('✅ Login API call successful');
      return data;
    } catch (error) {
      console.error('❌ Login API error:', error);
      throw error;
    }
  },

  /**
   * Test backend connection
   */
  async testConnection(): Promise<any> {
    try {
      const response = await fetch(`${API_BASE_URL}/health`);
      return await response.json();
    } catch (error) {
      console.error('Connection test failed:', error);
      throw error;
    }
  }
};